class AddOnProductsManager {
  constructor() {
    this.vehicleSelector = document.querySelector('vehicle-model-selector');
    this.generationSelector = document.querySelector('.generation-selector');
    this.addOnProductsFieldset = document.getElementById('add-on-products');
    this.addOnProducts = this.addOnProductsFieldset.querySelectorAll('.add-on-product-wrapper');
    this.selectedVehicle = '';
    this.selectedGeneration = '';

    this.init();
  }

  init() {
    if (this.vehicleSelector) {
      this.vehicleSelector.addEventListener('vehicleSelected', this.handleVehicleSelection.bind(this));
    }

    if (this.generationSelector) {
      this.generationSelector.addEventListener('click', this.handleGenerationSelection.bind(this));
    }

    // Initially hide all add-on products and the fieldset
    this.addOnProducts.forEach((product) => {
      product.style.display = 'none';
    });
    this.addOnProductsFieldset.style.display = 'none';
  }

  handleGenerationSelection(event) {
    if (event.target.matches('.disclosure__link')) {
      this.selectedGeneration = event.target.textContent.trim();
      this.updateAddOnProducts();
    }
  }

  handleVehicleSelection(event) {
    this.selectedVehicle = event.detail.value.toLowerCase();
    this.updateAddOnProducts();
  }

  updateAddOnProducts() {
    let visibleAddOns = 0;

    this.addOnProducts.forEach((product, index) => {
      const checkbox = product.querySelector('.add-on-checkbox');
      const compatibleVehiclesString = checkbox ? checkbox.dataset.compatibleVehicles : '';
      const compatibleGeneration = checkbox ? checkbox.dataset.compatibleGeneration : '';

      let shouldRender = false;

      // FIXED: Treat empty string as "no compatible vehicles" instead of "compatible with all"
      if (!compatibleVehiclesString || compatibleVehiclesString.trim() === '') {
        // If no compatible vehicle is specified, don't render (hide the add-on)
        shouldRender = false;
      } else {
        const isVehicleCompatible = this.isVehicleCompatible(this.selectedVehicle, compatibleVehiclesString);

        if (!compatibleGeneration) {
          // If no generation is specified, render only if vehicle is compatible
          shouldRender = isVehicleCompatible;
        } else {
          // If generation is specified, render only if both vehicle and generation are compatible
          shouldRender = isVehicleCompatible && compatibleGeneration === this.selectedGeneration;
        }
      }

      product.style.display = shouldRender ? 'block' : 'none';

      if (shouldRender) {
        visibleAddOns++;
      }

      if (checkbox) {
        checkbox.checked = shouldRender;
        checkbox.disabled = !shouldRender;
      }
    });

    // Show or hide the entire fieldset based on whether there are visible add-ons
    this.addOnProductsFieldset.style.display = visibleAddOns > 0 ? 'block' : 'none';
  }

  isVehicleCompatible(selectedVehicle, compatibleVehiclesString) {
    if (!selectedVehicle) return false; // If no vehicle is selected, consider it incompatible
    const compatibleVehicle = compatibleVehiclesString.toLowerCase();
    const [make, model] = compatibleVehicle.split('|')[0].trim().split(' ');
    const result = selectedVehicle.includes(make) && selectedVehicle.includes(model);

    return result;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AddOnProductsManager();
});
